export const RESOURCE_TYPE_JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS =
	'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';

export const RESOURCE_TYPE_JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS =
	'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';
